module.exports = __webpack_public_path__ + "static/img/14000509.a9e4355d.png";